(function () {
  var config = window.ThemeRevenueEngineConfig || {};
  var nativeFetch = window.__nsNativeFetch || window.fetch;
  var currencyFormatter = null;
  var precheckoutTarget = null;
  var precheckoutBypass = false;
  var giftSyncBusy = false;
  var recentlyViewedQuickAddBound = false;

  function debug() {
    if (!config.debug || !window.console) return;
    window.console.log.apply(window.console, ['[ThemeRevenueEngine]'].concat([].slice.call(arguments)));
  }

  function fetchJson(url, options) {
    return nativeFetch(url, options).then(function (response) {
      return response.json().then(function (json) {
        if (!response.ok) {
          var error = new Error(json && (json.description || json.message) || 'Request failed');
          error.response = response;
          error.payload = json;
          throw error;
        }
        return json;
      });
    });
  }

  function formatMoney(cents) {
    var amount = Number(cents || 0) / 100;
    if (!currencyFormatter) {
      currencyFormatter = new Intl.NumberFormat(config.locale || 'en-IN', {
        style: 'currency',
        currency: config.currency || 'INR',
        maximumFractionDigits: amount % 1 === 0 ? 0 : 2
      });
    }
    return currencyFormatter.format(amount);
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[character];
    });
  }

  function parseAmountToCents(value) {
    if (typeof value === 'number') return Math.round(value * 100);
    var cleaned = String(value || '').replace(/[^0-9.]/g, '');
    return Math.round(Number(cleaned || 0) * 100);
  }

  function createAttributionEventId(source) {
    return [
      'ns',
      String(source || 'revenue').replace(/[^a-z0-9_]+/gi, '_').toLowerCase(),
      Date.now().toString(36),
      Math.random().toString(36).slice(2, 8)
    ].join('_');
  }

  function buildAttributionProperties(source, options) {
    options = options || {};
    var properties = {
      _ns_module: 'revenue_engine',
      _ns_source: source || 'revenue_engine',
      _ns_event_id: options.eventId || createAttributionEventId(source),
      _ns_added_at: options.addedAt || new Date().toISOString()
    };

    if (options.role) properties._ns_role = options.role;
    if (options.productId) properties._ns_product_id = String(options.productId);
    if (options.variantId) properties._ns_variant_id = String(options.variantId);
    if (options.parentProductId) properties._ns_parent_product_id = String(options.parentProductId);
    if (options.parentVariantId) properties._ns_parent_variant_id = String(options.parentVariantId);
    if (options.moduleTitle) properties._ns_module_title = String(options.moduleTitle);

    return properties;
  }

  function mergeAttributionProperties(existing, source, options) {
    var properties = Object.assign({}, existing || {});
    var attribution = buildAttributionProperties(source, options);
    Object.keys(attribution).forEach(function (key) {
      if (properties[key] == null || properties[key] === '') {
        properties[key] = attribution[key];
      }
    });
    return properties;
  }

  function appendFormAttribution(formData, source, options) {
    var attribution = buildAttributionProperties(source, options);
    Object.keys(attribution).forEach(function (key) {
      formData.set('properties[' + key + ']', attribution[key]);
    });
    return formData;
  }

  function normalizeCartAddItem(item, source, options) {
    var normalized = Object.assign({}, item || {});
    var itemAttribution = Object.assign({ variantId: normalized.id }, options || {}, normalized.attribution || {});
    normalized.properties = mergeAttributionProperties(normalized.properties, source, itemAttribution);
    delete normalized.source;
    delete normalized.attribution;
    delete normalized.eventId;
    return normalized;
  }

  function cartGet() {
    return fetchJson((config.routes && config.routes.cart) || '/cart.js', {
      headers: { Accept: 'application/json' }
    });
  }

  function cartAdd(payload) {
    var source = payload && payload.source || 'revenue_engine';
    var eventId = payload && payload.eventId || createAttributionEventId(source);
    var attributionOptions = Object.assign({ eventId: eventId }, payload && payload.attribution || {});
    var rawItems = payload && payload.items ? payload.items : (Array.isArray(payload) ? payload : [payload]);
    var body = {
      items: rawItems.map(function (item) {
        return normalizeCartAddItem(item, source, attributionOptions);
      })
    };
    return fetchJson((config.routes && config.routes.add) || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (json) {
      track('upsell_added', { source: source, event_id: eventId });
      return json;
    });
  }

  function cartChange(payload) {
    return fetchJson((config.routes && config.routes.change) || '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    });
  }

  function cartRefresh(openDrawer) {
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, cancelable: false }));
    document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true, cancelable: false }));
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true, cancelable: false }));
    if (openDrawer) {
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { bubbles: true, cancelable: false }));
    }
  }

  function track(eventName, payload) {
    var data = Object.assign({ event: eventName, source: 'nidharshana_revenue_engine' }, payload || {});
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
    debug('track', data);
  }

  function getRecommendations(context) {
    context = context || {};
    if (!context.productId) return Promise.resolve([]);
    var limit = context.limit || 4;
    var url = ((config.routes && config.routes.recommendations) || '/recommendations/products') + '.json?product_id=' + encodeURIComponent(context.productId) + '&limit=' + encodeURIComponent(limit);
    return fetchJson(url, { headers: { Accept: 'application/json' } })
      .then(function (json) { return json && json.products ? json.products : []; })
      .catch(function (error) {
        debug('recommendations failed', error);
        return [];
      });
  }

  var recentlyViewed = {
    baseKey: 'ns_recently_viewed_products_v2',
    guestKey: 'ns_recently_viewed_products_v2:guest',
    get key() {
      return config.customerId ? recentlyViewed.baseKey + ':customer:' + config.customerId : recentlyViewed.guestKey;
    },
    get viewCountKey() {
      return recentlyViewed.key + ':session_views';
    },
    getSessionViews: function () {
      try {
        return JSON.parse(window.sessionStorage.getItem(recentlyViewed.viewCountKey) || '{}');
      } catch (error) {
        return {};
      }
    },
    incrementSessionView: function (handle) {
      if (!handle) return 0;
      try {
        var views = recentlyViewed.getSessionViews();
        views[handle] = Number(views[handle] || 0) + 1;
        window.sessionStorage.setItem(recentlyViewed.viewCountKey, JSON.stringify(views));
        return views[handle];
      } catch (error) {
        return 1;
      }
    },
    mergeGuestHistory: function () {
      if (!config.customerId) return;
      try {
        var guestList = JSON.parse(window.localStorage.getItem(recentlyViewed.guestKey) || '[]');
        if (!guestList.length) return;
        var currentList = recentlyViewed.get();
        var merged = guestList.concat(currentList).reduce(function (items, item) {
          if (!item || !item.handle || items.some(function (existing) { return existing.handle === item.handle; })) return items;
          items.push(item);
          return items;
        }, []);
        window.localStorage.setItem(recentlyViewed.key, JSON.stringify(merged.slice(0, 24)));
        window.localStorage.removeItem(recentlyViewed.guestKey);
      } catch (error) {
        debug('recently viewed merge failed', error);
      }
    },
    normalize: function (product, sessionViews) {
      var stored = Object.assign({}, product || {});
      delete stored.variants;
      stored.sessionViews = Number(sessionViews || stored.sessionViews || 0);
      stored.timestamp = Date.now();
      stored.price = stored.price || (stored.priceCents ? formatMoney(stored.priceCents) : '');
      if (stored.variantId && stored.baseUrl && String(stored.url || '').indexOf('variant=') === -1) {
        stored.url = stored.baseUrl + (stored.baseUrl.indexOf('?') === -1 ? '?' : '&') + 'variant=' + encodeURIComponent(stored.variantId);
      }
      return stored;
    },
    save: function (product, options) {
      if (!product || !product.handle) return;
      options = options || {};
      try {
        var existing = recentlyViewed.get().find(function (item) { return item.handle === product.handle; });
        var sessionViews = existing && existing.sessionViews || recentlyViewed.getSessionViews()[product.handle] || 0;
        if (options.increment !== false) {
          sessionViews = recentlyViewed.incrementSessionView(product.handle);
        }
        var list = recentlyViewed.get().filter(function (item) { return item.handle !== product.handle; });
        list.unshift(recentlyViewed.normalize(product, sessionViews));
        window.localStorage.setItem(recentlyViewed.key, JSON.stringify(list.slice(0, 24)));
      } catch (error) {
        debug('recently viewed save failed', error);
      }
    },
    get: function () {
      try {
        return JSON.parse(window.localStorage.getItem(recentlyViewed.key) || '[]');
      } catch (error) {
        return [];
      }
    }
  };

  function getRecentProductViewData() {
    var dataNode = document.querySelector('[data-revenue-product-view]');
    if (!dataNode) return null;
    try {
      return JSON.parse(dataNode.textContent);
    } catch (error) {
      debug('product view parse failed', error);
      return null;
    }
  }

  function syncPdpUrgencyNudges(product) {
    var nudges = document.querySelectorAll('[data-ns-urgency-nudge]');
    var strips = document.querySelectorAll('[data-ns-fomo-strip]');
    if (!nudges.length && !strips.length) return;
    var data = product || getRecentProductViewData() || {};
    var sessionViews = recentlyViewed.getSessionViews();

    nudges.forEach(function (nudge) {
      var tone = nudge.dataset.urgencyTone || 'default';
      var handle = nudge.dataset.productHandle || data.handle;
      var views = Number(sessionViews[handle] || data.sessionViews || 0);
      var threshold = Number(nudge.dataset.repeatThreshold || 2);
      var repeatMessage = nudge.dataset.repeatMessage || '';
      var text = nudge.querySelector('[data-ns-urgency-text]');
      var label = nudge.querySelector('[data-ns-urgency-label]');
      if (tone !== 'default' || views < threshold || !repeatMessage || !text) return;

      text.textContent = repeatMessage;
      if (label) label.textContent = 'Still interested:';
      nudge.dataset.urgencyTone = 'repeat';
    });

    strips.forEach(function (strip) {
      var tone = strip.dataset.fomoPrimaryTone || 'default';
      var handle = strip.dataset.productHandle || data.handle;
      var views = Number(sessionViews[handle] || data.sessionViews || 0);
      var threshold = Number(strip.dataset.repeatThreshold || 2);
      var repeatMessage = strip.dataset.repeatMessage || '';
      var primaryBadge = strip.querySelector('[data-ns-fomo-primary]');
      var text = strip.querySelector('[data-ns-fomo-primary-text]');
      if (tone !== 'default' || views < threshold || !repeatMessage || !text) return;

      text.textContent = repeatMessage;
      strip.dataset.fomoPrimaryTone = 'repeat';
      if (primaryBadge) {
        primaryBadge.dataset.fomoTone = 'repeat';
        primaryBadge.classList.add('ns-pdp-fomo-strip__badge--repeat');
      }
    });
  }

  function getRecentFomo(item, root) {
    if (root.dataset.fomoEnabled !== 'true') return null;
    var sellingThreshold = Number(root.dataset.sellingFastThreshold || 2);
    if (Number(item.sessionViews || 0) >= sellingThreshold) {
      return { text: root.dataset.sellingFastLabel || 'Selling fast', type: 'hot' };
    }
    var lowStockThreshold = Number(root.dataset.lowStockThreshold || 5);
    if (item.inventoryManaged && Number(item.inventoryQuantity || 0) > 0 && Number(item.inventoryQuantity || 0) <= lowStockThreshold) {
      return {
        text: (root.dataset.lowStockLabel || 'Only [count] left').replace('[count]', item.inventoryQuantity),
        type: 'low'
      };
    }
    if (Number(item.compareAtPriceCents || 0) > Number(item.priceCents || 0)) {
      return { text: root.dataset.saleLabel || 'Limited deal', type: 'sale' };
    }
    return { text: root.dataset.fallbackFomoLabel || 'Customer favourite', type: 'soft' };
  }

  function renderRecentPrice(item) {
    var price = item.price || (item.priceCents ? formatMoney(item.priceCents) : '');
    var compareAt = Number(item.compareAtPriceCents || 0);
    var priceCents = Number(item.priceCents || 0);
    var html = '<div class="revenue-recent-card__price-row"><span class="revenue-recent-card__price">' + escapeHtml(price) + '</span>';
    if (compareAt > priceCents) {
      html += '<span class="revenue-recent-card__compare">' + escapeHtml(formatMoney(compareAt)) + '</span>';
    }
    html += '</div>';
    return html;
  }

  function renderRecentAction(item, root) {
    if (root.dataset.quickAdd !== 'true') return '';
    if (root.dataset.selectionMode === 'batch') {
      if (!item.variantId || item.available === false) return '';
      return '<label class="revenue-recent-card__select" aria-label="Select ' + escapeHtml(item.title) + '">' +
        '<input type="checkbox" data-revenue-recent-select data-variant-id="' + escapeHtml(item.variantId) + '" data-product-id="' + escapeHtml(item.id || '') + '" data-price-cents="' + escapeHtml(item.priceCents || 0) + '" data-title="' + escapeHtml(item.title) + '">' +
        '<span class="revenue-recent-card__check" aria-hidden="true"><svg viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 9.2l3.1 3.1L14 5.6"></path></svg></span>' +
        '<span class="revenue-recent-card__select-text revenue-recent-card__select-text--off">Select</span>' +
        '<span class="revenue-recent-card__select-text revenue-recent-card__select-text--on">Selected</span>' +
        '</label>';
    }
    var soldOutLabel = root.dataset.soldOutLabel || 'Sold out';
    if (!item.variantId || item.available === false) {
      return '<button type="button" class="revenue-recent-card__button revenue-recent-card__button--sold" disabled>' + escapeHtml(soldOutLabel) + '</button>';
    }
    return '<button type="button" class="revenue-recent-card__button" data-revenue-recent-add data-variant-id="' + escapeHtml(item.variantId) + '" data-product-id="' + escapeHtml(item.id || '') + '" data-added-label="' + escapeHtml(root.dataset.addedLabel || 'Added') + '">' + escapeHtml(root.dataset.addLabel || 'Add to Cart') + '</button>';
  }

  function renderRecentlyViewedCard(item, root) {
    var fomo = getRecentFomo(item, root);
    var variant = item.variantTitle && item.variantTitle !== 'Default Title' ? '<p class="revenue-recent-card__variant">' + escapeHtml(item.variantTitle) + '</p>' : '';
    var showSitewideOffer = root.dataset.sitewideOfferEnabled === 'true' && root.dataset.sitewideOfferText && (item.available !== false || root.dataset.sitewideOfferShowSoldOut === 'true');
    var showFomoBadge = fomo && (!showSitewideOffer || fomo.type === 'low');
    var sitewideOffer = '';
    if (showSitewideOffer) {
      sitewideOffer = '<span class="ns-sitewide-offer-badge" aria-label="' + escapeHtml(((root.dataset.sitewideOfferCampaign || '') + ' ' + root.dataset.sitewideOfferText).trim()) + '">' +
        (root.dataset.sitewideOfferCampaign ? '<span class="ns-sitewide-offer-badge__campaign">' + escapeHtml(root.dataset.sitewideOfferCampaign) + '</span>' : '') +
        '<span class="ns-sitewide-offer-badge__offer">' + escapeHtml(root.dataset.sitewideOfferText) + '</span>' +
        '</span>';
    }
    return '<article class="revenue-recent-card">' +
      '<a class="revenue-recent-card__media" href="' + escapeHtml(item.url) + '">' +
      (item.image ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title) + '" loading="lazy">' : '') +
      (showFomoBadge ? '<span class="revenue-recent-card__badge revenue-recent-card__badge--' + escapeHtml(fomo.type) + '">' + escapeHtml(fomo.text) + '</span>' : '') +
      sitewideOffer +
      '</a>' +
      '<div class="revenue-recent-card__body">' +
      '<a class="revenue-recent-card__title" href="' + escapeHtml(item.url) + '">' + escapeHtml(item.title) + '</a>' +
      variant +
      renderRecentPrice(item) +
      (fomo ? '<p class="revenue-recent-card__fomo">' + escapeHtml(fomo.text) + '</p>' : '') +
      renderRecentAction(item, root) +
      '</div>' +
      '</article>';
  }

  function getSelectedRecentInputs(root) {
    if (!root) return [];
    return Array.prototype.slice.call(root.querySelectorAll('[data-revenue-recent-select]:checked'));
  }

  function updateRecentlyViewedBatchState(root) {
    if (!root) return;
    var batch = root.querySelector('[data-revenue-recent-batch]');
    if (!batch) return;
    var batchMode = root.dataset.quickAdd === 'true' && root.dataset.selectionMode === 'batch';
    var inputs = Array.prototype.slice.call(root.querySelectorAll('[data-revenue-recent-select]'));
    if (!batchMode || !inputs.length) {
      batch.hidden = true;
      return;
    }

    var selected = getSelectedRecentInputs(root);
    var count = root.querySelector('[data-revenue-recent-batch-count]');
    var total = root.querySelector('[data-revenue-recent-batch-total]');
    var button = root.querySelector('[data-revenue-recent-batch-add]');
    var totalCents = selected.reduce(function (sum, input) {
      return sum + Number(input.dataset.priceCents || 0);
    }, 0);

    batch.hidden = false;
    inputs.forEach(function (input) {
      var card = input.closest('.revenue-recent-card');
      if (card) card.classList.toggle('is-selected', input.checked);
    });
    if (count) {
      count.textContent = selected.length ? selected.length + (selected.length === 1 ? ' saree selected' : ' sarees selected') : root.dataset.batchEmptyLabel || 'Select sarees to add together';
    }
    if (total) {
      total.hidden = selected.length === 0;
      if (selected.length) total.textContent = 'Selected total: ' + formatMoney(totalCents);
    }
    if (button) button.disabled = selected.length === 0 || button.dataset.busy === 'true';
  }

  function renderRecentlyViewedRoot(root) {
    var current = root.dataset.currentHandle;
    var list = recentlyViewed.get().filter(function (item) { return item.handle !== current; });
    if (root.dataset.quickAdd === 'true') {
      list = list.filter(function (item) {
        return item.variantId && item.available !== false;
      });
    }
    list = list.slice(0, Number(root.dataset.limit || 8));
    var grid = root.querySelector('[data-revenue-recent-grid]');
    if (!grid || !list.length) {
      if (grid && root.dataset.editorPreview !== 'true') grid.innerHTML = '';
      updateRecentlyViewedBatchState(root);
      if (root.dataset.editorPreview === 'true' && grid && grid.children.length) {
        root.hidden = false;
      } else {
        root.hidden = true;
      }
      return;
    }
    grid.innerHTML = list.map(function (item) { return renderRecentlyViewedCard(item, root); }).join('');
    updateRecentlyViewedBatchState(root);
    root.hidden = false;
  }

  function renderRecentlyViewedSections() {
    document.querySelectorAll('[data-revenue-recently-viewed]').forEach(renderRecentlyViewedRoot);
  }

  function bindRecentlyViewedVariantSync(productViewData) {
    if (!productViewData || !productViewData.variants || document.documentElement.dataset.revenueRecentVariantBound === 'true') return;
    document.documentElement.dataset.revenueRecentVariantBound = 'true';
    document.addEventListener('on:variant:change', function (event) {
      var variantId = event.detail && event.detail.variant && event.detail.variant.id;
      if (!variantId) return;
      var latestNode = document.querySelector('[data-revenue-product-view]');
      var latestData = getRecentProductViewData() || productViewData;
      var variant = (latestData.variants || productViewData.variants || []).find(function (item) {
        return Number(item.id) === Number(variantId);
      });
      if (!variant) return;
      var snapshot = Object.assign({}, latestData, {
        url: variant.url,
        image: variant.image || latestData.image,
        price: variant.price,
        priceCents: variant.priceCents,
        compareAtPriceCents: variant.compareAtPriceCents,
        variantId: variant.id,
        variantTitle: variant.title,
        available: variant.available,
        inventoryManaged: variant.inventoryManaged,
        inventoryQuantity: variant.inventoryQuantity
      });
      recentlyViewed.save(snapshot, { increment: false });
      if (latestNode) latestNode.dataset.revenueSaved = 'true';
      renderRecentlyViewedSections();
      syncPdpUrgencyNudges(snapshot);
    });
  }

  function bindRecentlyViewed() {
    recentlyViewed.mergeGuestHistory();

    var dataNode = document.querySelector('[data-revenue-product-view]');
    var productViewData = getRecentProductViewData();
    if (dataNode && productViewData && dataNode.dataset.revenueSaved !== 'true') {
      recentlyViewed.save(productViewData);
      dataNode.dataset.revenueSaved = 'true';
      bindRecentlyViewedVariantSync(productViewData);
    }
    syncPdpUrgencyNudges(productViewData);

    document.querySelectorAll('[data-revenue-recently-viewed]').forEach(function (root) {
      renderRecentlyViewedRoot(root);

      var grid = root.querySelector('[data-revenue-recent-grid]');
      if (!grid) return;
      var previous = root.querySelector('[data-revenue-recent-prev]');
      var next = root.querySelector('[data-revenue-recent-next]');
      function scrollRail(direction) {
        var card = grid.querySelector('.revenue-recent-card');
        var step = card ? card.getBoundingClientRect().width + 14 : grid.clientWidth * 0.8;
        grid.scrollBy({ left: direction * Math.max(step, grid.clientWidth * 0.74), behavior: 'smooth' });
      }
      if (previous && previous.dataset.bound !== 'true') {
        previous.dataset.bound = 'true';
        previous.addEventListener('click', function () { scrollRail(-1); });
      }
      if (next && next.dataset.bound !== 'true') {
        next.dataset.bound = 'true';
        next.addEventListener('click', function () { scrollRail(1); });
      }
    });
  }

  function bindRecentlyViewedQuickAdd() {
    if (recentlyViewedQuickAddBound) return;
    recentlyViewedQuickAddBound = true;
    document.addEventListener('change', function (event) {
      var input = event.target.closest('[data-revenue-recent-select]');
      if (!input) return;
      var root = input.closest('[data-revenue-recently-viewed]');
      updateRecentlyViewedBatchState(root);
    });

    document.addEventListener('click', function (event) {
      var batchButton = event.target.closest('[data-revenue-recent-batch-add]');
      if (batchButton) {
        event.preventDefault();
        if (batchButton.disabled || batchButton.dataset.busy === 'true') return;
        var root = batchButton.closest('[data-revenue-recently-viewed]');
        var selected = getSelectedRecentInputs(root);
        if (!root || !selected.length) return;
        var originalText = batchButton.textContent;
        batchButton.dataset.busy = 'true';
        batchButton.disabled = true;
        batchButton.textContent = root.dataset.batchAddingLabel || 'Adding...';
        selected.forEach(function (input) { input.disabled = true; });
        var items = selected.map(function (input) {
          return {
            id: Number(input.dataset.variantId),
            quantity: 1,
            properties: { _recently_viewed: 'true' },
            attribution: {
              role: 'add_on',
              productId: input.dataset.productId,
              variantId: input.dataset.variantId
            }
          };
        }).filter(function (item) {
          return item.id;
        });
        if (!items.length) {
          batchButton.dataset.busy = 'false';
          selected.forEach(function (input) { input.disabled = false; });
          updateRecentlyViewedBatchState(root);
          return;
        }
        cartAdd({
          items: items,
          source: 'recently_viewed_batch'
        }).then(function () {
          batchButton.textContent = root.dataset.batchAddedLabel || 'Added selected';
          selected.forEach(function (input) { input.checked = false; });
          updateRecentlyViewedBatchState(root);
          cartRefresh(true);
        }).catch(function (error) {
          debug('recently viewed batch add failed', error);
          batchButton.textContent = originalText;
        }).finally(function () {
          window.setTimeout(function () {
            batchButton.dataset.busy = 'false';
            batchButton.textContent = originalText;
            selected.forEach(function (input) { input.disabled = false; });
            updateRecentlyViewedBatchState(root);
          }, 900);
        });
        return;
      }

      var button = event.target.closest('[data-revenue-recent-add]');
      if (!button || button.disabled) return;
      event.preventDefault();
      var originalText = button.textContent;
      button.disabled = true;
      cartAdd({
        items: [{
          id: Number(button.dataset.variantId),
          quantity: 1,
          properties: { _recently_viewed: 'true' },
          attribution: {
            role: 'add_on',
            productId: button.dataset.productId,
            variantId: button.dataset.variantId
          }
        }],
        source: 'recently_viewed'
      }).then(function () {
        button.textContent = button.dataset.addedLabel || 'Added';
        cartRefresh(true);
      }).catch(function (error) {
        debug('recently viewed add failed', error);
        button.disabled = false;
        button.textContent = originalText;
      });
    });
  }

  function bindDiscountField() {
    document.addEventListener('submit', function (event) {
      var form = event.target.closest('[data-revenue-discount-form]');
      if (!form) return;
      event.preventDefault();
      var input = form.querySelector('[data-revenue-discount-input]');
      var code = input ? input.value.trim() : '';
      if (!code) return;
      try {
        window.localStorage.setItem('ns_revenue_discount_code', code);
      } catch (error) {}
      form.querySelector('[data-revenue-discount-note]').textContent = 'Code saved. It will be applied at checkout where supported.';
      track('discount_entered', { code: code });
    });
  }

  function applyDiscountToCheckout(url) {
    if (!config.discount || !config.discount.enabled) return url;
    var code = '';
    try {
      code = window.localStorage.getItem('ns_revenue_discount_code') || '';
    } catch (error) {}
    if (!code) return url;
    return '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(url || '/checkout');
  }

  function hasAutoGift(cart, variantId) {
    return (cart.items || []).find(function (item) {
      return String(item.variant_id) === String(variantId) && item.properties && item.properties._auto_gift === 'true';
    });
  }

  function syncAutoGift() {
    if (!config.autoGift || !config.autoGift.enabled || !config.autoGift.variantId || giftSyncBusy) return;
    giftSyncBusy = true;
    cartGet().then(function (cart) {
      var threshold = parseAmountToCents(config.autoGift.threshold);
      var existing = hasAutoGift(cart, config.autoGift.variantId);
      if (cart.total_price >= threshold && !existing) {
        return cartAdd({
          id: Number(config.autoGift.variantId),
          quantity: 1,
          properties: { _auto_gift: 'true' },
          source: 'auto_gift',
          attribution: { role: 'gift' }
        }).then(function () {
          track('gift_added', { gift_type: 'auto' });
          cartRefresh(false);
        });
      }
      if (cart.total_price < threshold && existing && config.autoGift.removeBelow) {
        return cartChange({ id: existing.key, quantity: 0 }).then(function () {
          cartRefresh(false);
        });
      }
    }).catch(function (error) {
      debug('auto gift sync failed', error);
    }).finally(function () {
      giftSyncBusy = false;
    });
  }

  function bindGiftButtons() {
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-revenue-gift-add]');
      if (!button || button.disabled) return;
      event.preventDefault();
      button.disabled = true;
      cartAdd({
        id: Number(button.dataset.variantId),
        quantity: 1,
        properties: { _selectable_gift: 'true' },
        source: 'selectable_gift',
        attribution: { role: 'gift' }
      }).then(function () {
        track('gift_added', { gift_type: 'selectable' });
        cartRefresh(true);
      }).catch(function (error) {
        debug('selectable gift failed', error);
      }).finally(function () {
        button.disabled = false;
      });
    });
  }

  function bindSubscriptionSwitch() {
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-revenue-switch-selling-plan]');
      if (!button || button.disabled) return;
      event.preventDefault();
      button.disabled = true;
      cartChange({
        id: button.dataset.lineKey,
        quantity: Number(button.dataset.quantity || 1),
        selling_plan: Number(button.dataset.sellingPlanId)
      }).then(function () {
        cartRefresh(true);
      }).catch(function (error) {
        debug('selling plan switch failed', error);
      }).finally(function () {
        button.disabled = false;
      });
    });
  }

  function bindPdpAddons() {
    document.querySelectorAll('[data-revenue-pdp-addons]').forEach(function (root) {
      if (root.dataset.bound === 'true') return;
      root.dataset.bound = 'true';
      var section = root.closest('[data-ns-pdp]');
      var form = section && section.querySelector('.js-product-form');
      if (!form) return;
      form.addEventListener('submit', function (event) {
        var selected = [].slice.call(root.querySelectorAll('[data-revenue-addon-input]:checked'));
        if (!selected.length || form.dataset.revenueAddonSubmitting === 'true') return;
        event.preventDefault();
        event.stopImmediatePropagation();
        form.dataset.revenueAddonSubmitting = 'true';

        var submitButton = form.querySelector('[name="add"]');
        if (submitButton) submitButton.setAttribute('aria-disabled', 'true');
        var eventId = createAttributionEventId('pdp_addons');
        var parentVariantInput = form.querySelector('[name="id"]');
        var parentProductId = form.dataset.productId;
        var parentVariantId = parentVariantInput && parentVariantInput.value;

        Promise.resolve().then(function () {
          if (form.dataset.nsAdvanceOrder === 'true') {
            var consentHelper = window.NSAdvanceOrderConsent && window.NSAdvanceOrderConsent.ensureProductConsent;
            return consentHelper ? consentHelper(form) : false;
          }
          return true;
        }).then(function (consentOk) {
          if (!consentOk) throw new Error('advance-consent-required');
          var formData = new FormData(form);
          appendFormAttribution(formData, 'pdp_addons', {
            eventId: eventId,
            role: 'main',
            parentProductId: parentProductId,
            parentVariantId: parentVariantId
          });
          return nativeFetch((config.routes && config.routes.add) || '/cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: formData
          }).then(function (response) {
            response.nsEventId = eventId;
            return response;
          });
        }).then(function (response) {
          if (!response.ok) throw new Error('main-add-failed');
          var eventId = response.nsEventId || createAttributionEventId('pdp_addons');
          var addonItems = selected.map(function (input) {
            return {
              id: Number(input.value),
              quantity: 1,
              properties: { _pdp_addon: 'true' },
              attribution: {
                role: 'add_on',
                parentProductId: parentProductId,
                parentVariantId: parentVariantId
              }
            };
          });
          return cartAdd({ items: addonItems, source: 'pdp_addons', eventId: eventId });
        }).then(function () {
          track('upsell_added', { source: 'pdp_addons', count: selected.length, event_id: eventId });
          cartRefresh(true);
        }).catch(function (error) {
          debug('pdp addons failed', error);
        }).finally(function () {
          delete form.dataset.revenueAddonSubmitting;
          if (submitButton) submitButton.removeAttribute('aria-disabled');
        });
      }, true);
    });
  }

  function bindUpgradeModal() {
    document.querySelectorAll('[data-revenue-upgrade-modal]').forEach(function (modal) {
      if (modal.dataset.bound === 'true') return;
      modal.dataset.bound = 'true';
      var section = modal.closest('[data-ns-pdp]');
      if (!section) return;
      section.addEventListener('on:cart:add', function (event) {
        if (modal.dataset.shown === 'true' || window.sessionStorage.getItem('ns_upgrade_seen_' + modal.dataset.productId) === 'true') return;
        modal.dataset.originalVariantId = event.detail && event.detail.variantId;
        modal.hidden = false;
        modal.dataset.shown = 'true';
        window.sessionStorage.setItem('ns_upgrade_seen_' + modal.dataset.productId, 'true');
        track('checkout_popup_viewed', { type: 'product_upgrade', product_id: modal.dataset.productId });
      });
    });

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-revenue-upgrade-action]');
      if (!button) return;
      var modal = button.closest('[data-revenue-upgrade-modal]');
      if (!modal) return;
      var action = button.dataset.revenueUpgradeAction;
      if (action === 'decline') {
        modal.hidden = true;
        cartRefresh(true);
        return;
      }
      button.disabled = true;
      var promise = Promise.resolve();
      if (action === 'replace' && modal.dataset.originalVariantId) {
        promise = cartGet().then(function (cart) {
          var line = (cart.items || []).find(function (item) { return String(item.variant_id) === String(modal.dataset.originalVariantId); });
          return line ? cartChange({ id: line.key, quantity: 0 }) : null;
        });
      }
      promise.then(function () {
        return cartAdd({
          id: Number(modal.dataset.upgradeVariantId),
          quantity: 1,
          properties: { _upgrade_upsell: action },
          source: 'product_upgrade_upsell',
          attribution: {
            role: 'add_on',
            parentProductId: modal.dataset.productId,
            parentVariantId: modal.dataset.originalVariantId
          }
        });
      }).then(function () {
        track('checkout_popup_accepted', { type: 'product_upgrade', action: action });
        modal.hidden = true;
        cartRefresh(true);
      }).catch(function (error) {
        debug('upgrade failed', error);
      }).finally(function () {
        button.disabled = false;
      });
    });
  }

  function bindPrecheckout() {
    document.addEventListener('click', function (event) {
      var checkoutArea = event.target.closest('.checkout-buttons');
      if (!checkoutArea || !config.precheckout || !config.precheckout.enabled || precheckoutBypass) return;
      if (window.sessionStorage.getItem('ns_precheckout_seen') === 'true' && config.precheckout.once) return;
      precheckoutTarget = event.target.closest('a, button');
      if (!precheckoutTarget) return;
      event.preventDefault();
      event.stopPropagation();
      cartGet().then(function (cart) {
        if (cart.total_price < parseAmountToCents(config.precheckout.minCart)) {
          continueCheckout();
          return;
        }
        var modal = document.querySelector('[data-revenue-precheckout-modal]');
        if (!modal) {
          continueCheckout();
          return;
        }
        modal.hidden = false;
        window.sessionStorage.setItem('ns_precheckout_seen', 'true');
        track('checkout_popup_viewed', { type: 'precheckout' });
      }).catch(continueCheckout);
    }, true);

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-revenue-precheckout-action]');
      if (!button) return;
      var modal = button.closest('[data-revenue-precheckout-modal]');
      var action = button.dataset.revenuePrecheckoutAction;
      if (action === 'add' && button.dataset.variantId) {
        button.disabled = true;
        var eventId = createAttributionEventId('precheckout_offer');
        cartAdd({
          id: Number(button.dataset.variantId),
          quantity: 1,
          properties: { _precheckout_offer: 'true' },
          source: 'precheckout_offer',
          eventId: eventId,
          attribution: { role: 'add_on' }
        }).then(function () {
          track('checkout_popup_accepted', { type: 'precheckout', event_id: eventId });
          if (modal) modal.hidden = true;
          cartRefresh(false);
          continueCheckout();
        }).finally(function () { button.disabled = false; });
      } else {
        if (modal) modal.hidden = true;
        continueCheckout();
      }
    });
  }

  function continueCheckout() {
    if (!precheckoutTarget) return;
    precheckoutBypass = true;
    if (precheckoutTarget.tagName === 'A' && precheckoutTarget.getAttribute('href')) {
      var href = precheckoutTarget.getAttribute('href');
      window.location.href = href.indexOf('/checkout') !== -1 ? applyDiscountToCheckout(href) : href;
    } else {
      precheckoutTarget.click();
    }
    window.setTimeout(function () { precheckoutBypass = false; }, 1000);
  }

  function bindBundleBuilders() {
    document.querySelectorAll('[data-revenue-bundle]').forEach(function (root) {
      if (root.dataset.bound === 'true') return;
      root.dataset.bound = 'true';
      var isFbt = root.hasAttribute('data-revenue-fbt');
      var min = Number(root.dataset.min || (isFbt ? 1 : 1));
      var max = Number(root.dataset.max || 99);
      var button = root.querySelector('[data-revenue-bundle-add]');
      var countNode = root.querySelector('[data-revenue-bundle-count]');
      var totalNode = root.querySelector('[data-revenue-bundle-total]');
      var mainPriceNode = root.querySelector('[data-revenue-fbt-main-price]');
      var mainVariantNode = root.querySelector('[data-revenue-fbt-main-variant]');
      var variantsNode = root.querySelector('[data-revenue-fbt-variants]');
      var variants = [];
      var productForm = null;

      if (isFbt) {
        try {
          variants = variantsNode ? JSON.parse(variantsNode.textContent || '[]') : [];
        } catch (error) {
          variants = [];
        }
        productForm = document.querySelector('.js-product-form[data-product-id="' + root.dataset.productId + '"]') || document.querySelector('.js-product-form[data-ns-silent-add="true"]');
      }

      function getMainVariantId() {
        var input = productForm && productForm.querySelector('input[name="id"]');
        return input && input.value ? Number(input.value) : null;
      }

      function getMainVariant() {
        var id = getMainVariantId();
        return variants.find(function (variant) { return Number(variant.id) === Number(id); }) || variants[0] || null;
      }

      function updateImage(image, src, alt) {
        if (!image || !src) return;
        image.src = src;
        image.removeAttribute('srcset');
        if (alt) image.alt = alt;
      }

      function updateLinks(links, url) {
        if (!links || !url) return;
        links.forEach(function (link) {
          link.href = url;
        });
      }

      function updateSelectedVariant(select) {
        var card = select.closest('[data-revenue-fbt-card]');
        if (!card) return;
        var option = select.options[select.selectedIndex];
        var checkbox = card.querySelector('[data-revenue-bundle-item]');
        var priceNode = card.querySelector('[data-revenue-fbt-card-price]');
        var imageNode = card.querySelector('[data-revenue-fbt-card-image]');
        var linkNodes = card.querySelectorAll('[data-revenue-fbt-card-link]');
        if (checkbox && option) {
          checkbox.value = option.value;
          checkbox.dataset.price = option.dataset.price || '0';
        }
        if (priceNode && option) {
          priceNode.dataset.price = option.dataset.price || '0';
          priceNode.textContent = formatMoney(Number(option.dataset.price || 0));
        }
        if (option) {
          updateImage(imageNode, option.dataset.image, option.dataset.imageAlt);
          updateLinks(linkNodes, option.dataset.url);
        }
      }

      root.querySelectorAll('[data-revenue-fbt-variant-select]').forEach(function (select) {
        updateSelectedVariant(select);
        select.addEventListener('change', function () {
          updateSelectedVariant(select);
          update();
        });
      });

      function update() {
        var selected = root.querySelectorAll('[data-revenue-bundle-item]:checked');
        var selectedCount = selected.length;
        var total = 0;
        var mainVariant = isFbt ? getMainVariant() : null;

        if (isFbt && mainVariant) {
          var mainCard = root.querySelector('[data-revenue-fbt-main-card]');
          var mainImageNode = mainCard && mainCard.querySelector('[data-revenue-fbt-main-image]');
          var mainLinkNodes = mainCard ? mainCard.querySelectorAll('[data-revenue-fbt-main-link]') : [];
          selectedCount += 1;
          total += Number(mainVariant.price || 0);
          if (mainPriceNode) {
            mainPriceNode.dataset.price = mainVariant.price || 0;
            mainPriceNode.textContent = formatMoney(mainVariant.price || 0);
          }
          if (mainVariantNode) {
            mainVariantNode.textContent = mainVariant.title && mainVariant.title !== 'Default Title' ? mainVariant.title : '';
          }
          updateImage(mainImageNode, mainVariant.image, mainVariant.imageAlt);
          updateLinks(mainLinkNodes, mainVariant.url);
        }

        selected.forEach(function (input) {
          total += Number(input.dataset.price || 0);
        });

        if (countNode) countNode.textContent = selectedCount + ' selected';
        if (totalNode) totalNode.textContent = formatMoney(total);
        if (button) button.disabled = selectedCount < min || selectedCount > max || (isFbt && !getMainVariantId());
      }

      root.addEventListener('change', update);
      if (productForm) {
        productForm.addEventListener('change', update);
      }
      document.addEventListener('on:variant:change', update);
      update();

      if (button) {
        button.addEventListener('click', function () {
          var selected = [].slice.call(root.querySelectorAll('[data-revenue-bundle-item]:checked'));
          button.disabled = true;

          if (isFbt) {
            var eventId = createAttributionEventId('frequently_bought_together');
            var parentVariantInput = productForm && productForm.querySelector('[name="id"]');
            var parentProductId = productForm && productForm.dataset.productId;
            var parentVariantId = parentVariantInput && parentVariantInput.value;
            Promise.resolve().then(function () {
              if (!productForm) throw new Error('missing-product-form');
              if (productForm.dataset.nsAdvanceOrder === 'true') {
                var consentHelper = window.NSAdvanceOrderConsent && window.NSAdvanceOrderConsent.ensureProductConsent;
                return consentHelper ? consentHelper(productForm) : false;
              }
              return true;
            }).then(function (consentOk) {
              if (!consentOk) throw new Error('advance-consent-required');
              var formData = new FormData(productForm);
              formData.set('properties[_bundle]', root.dataset.bundleTitle || 'Frequently bought together');
              appendFormAttribution(formData, 'frequently_bought_together', {
                eventId: eventId,
                role: 'main',
                parentProductId: parentProductId,
                parentVariantId: parentVariantId,
                moduleTitle: root.dataset.bundleTitle || 'Frequently bought together'
              });
              return nativeFetch((config.routes && config.routes.add) || '/cart/add.js', {
                method: 'POST',
                headers: { Accept: 'application/json' },
                body: formData
              }).then(function (response) {
                response.nsEventId = eventId;
                return response;
              });
            }).then(function (response) {
              if (!response.ok) throw new Error('main-bundle-add-failed');
              var eventId = response.nsEventId || createAttributionEventId('frequently_bought_together');
              var addonItems = selected.map(function (input) {
                return {
                  id: Number(input.value),
                  quantity: 1,
                  properties: { _bundle: root.dataset.bundleTitle || 'Frequently bought together' },
                  attribution: {
                    role: 'add_on',
                    parentProductId: parentProductId,
                    parentVariantId: parentVariantId,
                    moduleTitle: root.dataset.bundleTitle || 'Frequently bought together'
                  }
                };
              });
              if (!addonItems.length) return null;
              return cartAdd({ items: addonItems, source: 'frequently_bought_together', eventId: eventId });
            }).then(function () {
              track('bundle_added', { type: 'frequently_bought_together', add_on_count: selected.length, event_id: eventId });
              cartRefresh(true);
            }).catch(function (error) {
              debug('frequently bought together failed', error);
            }).finally(function () {
              button.disabled = false;
              update();
            });
            return;
          }

          var items = selected.map(function (input) {
            return {
              id: Number(input.value),
              quantity: 1,
              properties: { _bundle: root.dataset.bundleTitle || 'Bundle' },
              attribution: { role: 'add_on', moduleTitle: root.dataset.bundleTitle || 'Bundle' }
            };
          });
          var eventId = createAttributionEventId('bundle_builder');
          cartAdd({ items: items, source: 'bundle_builder', eventId: eventId }).then(function () {
            track('bundle_added', { count: items.length, event_id: eventId });
            cartRefresh(true);
          }).finally(function () {
            button.disabled = false;
          });
        });
      }
    });
  }

  function bindReorderButtons() {
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-revenue-reorder-add]');
      if (!button || button.disabled) return;
      button.disabled = true;
      cartAdd({
        id: Number(button.dataset.variantId),
        quantity: 1,
        properties: { _reorder: 'true' },
        source: 'customer_reorder',
        attribution: { role: 'reorder' }
      }).then(function () {
        cartRefresh(true);
      }).finally(function () {
        button.disabled = false;
      });
    });
  }

  function bindTrackingEvents() {
    document.addEventListener('on:cart-drawer:after-open', function () {
      track('smart_cart_opened');
    });
    document.addEventListener('click', function (event) {
      var link = event.target.closest('.ns-cart-upsell-card a, .ns-pdp-upsell__card a, .revenue-recent-card a, .revenue-bundle-card a');
      if (!link) return;
      track('recommendation_clicked', { url: link.href });
    });
  }

  function assignExperiment(experimentId, split) {
    if (!config.abTestingEnabled || !experimentId) return 'A';
    var key = 'ns_ab_' + experimentId;
    try {
      var existing = window.localStorage.getItem(key);
      if (existing) return existing;
      var variant = Math.random() < Number(split || 0.5) ? 'B' : 'A';
      window.localStorage.setItem(key, variant);
      track('experiment_viewed', { experiment_id: experimentId, variant: variant });
      return variant;
    } catch (error) {
      return 'A';
    }
  }

  function init() {
    if (!config.enabled) return;
    bindRecentlyViewed();
    bindRecentlyViewedQuickAdd();
    bindDiscountField();
    bindGiftButtons();
    bindSubscriptionSwitch();
    bindPdpAddons();
    bindUpgradeModal();
    bindPrecheckout();
    bindBundleBuilders();
    bindReorderButtons();
    bindTrackingEvents();
    syncAutoGift();
    document.addEventListener('on:cart:change', syncAutoGift);
    document.addEventListener('cart:refresh', bindRecentlyViewed);
  }

  window.ThemeRevenueEngine = {
    cart: { add: cartAdd, change: cartChange, get: cartGet, refresh: cartRefresh },
    recommendations: { get: getRecommendations },
    recentlyViewed: recentlyViewed,
    discount: { applyOnCheckout: applyDiscountToCheckout },
    experiments: { assign: assignExperiment },
    track: track,
    createAttributionEventId: createAttributionEventId,
    buildAttributionProperties: buildAttributionProperties,
    appendFormAttribution: appendFormAttribution,
    formatMoney: formatMoney
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
